import React, { useEffect, useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { WHATSAPP_LINK } from '../constants';

const CONTACT_LINK = `${WHATSAPP_LINK}?text=${encodeURIComponent(
  'Hola, quiero saber si Áncora puede encargarse de una tarea concreta de mi negocio. Necesito ayuda con...',
)}`;

export const Chatbot: React.FC = () => {
  const { pathname } = useLocation();
  const [showLauncher, setShowLauncher] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (pathname !== '/') return undefined;

    const reveal = () => setShowLauncher(true);
    const timer = window.setTimeout(reveal, 20_000);
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.75) reveal();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pathname]);

  if (pathname !== '/' || !showLauncher) return null;

  return (
    <aside className="trust-chat" aria-label="Contacto con Áncora">
      {isOpen ? (
        <div className="trust-chat__panel">
          <button type="button" className="trust-chat__close" onClick={() => setIsOpen(false)} aria-label="Cerrar contacto">
            <X aria-hidden="true" size={17} />
          </button>
          <p className="trust-chat__label">Contacto</p>
          <h2>¿Qué debería hacer Áncora?</h2>
          <p>Cuéntanos qué mensajes recibes y qué debería ocurrir después. Te diremos si Áncora puede hacerlo.</p>
          <a href={CONTACT_LINK} target="_blank" rel="noreferrer">
            <MessageCircle aria-hidden="true" size={17} /> Escribir por WhatsApp
          </a>
          <button type="button" className="trust-chat__price" onClick={() => document.querySelector('#pricing')?.scrollIntoView({ behavior: 'smooth' })}>
            Ver precio inicial
          </button>
        </div>
      ) : (
        <button type="button" className="trust-chat__launcher" onClick={() => setIsOpen(true)}>
          <MessageCircle aria-hidden="true" size={18} /> Hablar con Áncora
        </button>
      )}
    </aside>
  );
};
